import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectProfileState } from '../user-profile.state'
import { Observable } from 'rxjs'
import { FormState } from 'ngrx-forms'
import { MatDialog } from '@angular/material/dialog'
import { ForgotPasswordDialogComponent } from '../user-access-data/forgot-password-dialog/forgot-password-dialog.component'

@Component({
  selector: 'cover-user-close-account',
  templateUrl: './user-close-account.component.html',
  styleUrls: ['./user-close-account.component.scss'],
})
export class UserCloseAccountComponent {
  formState$: Observable<FormState<string>>

  constructor(private readonly store: Store, private readonly dialog: MatDialog) {
    this.formState$ = this.store.select(selectProfileState.closeAccountState)
  }

  onForgotPassword(): void {
    this.dialog.open(ForgotPasswordDialogComponent)
  }
}
